import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import { EventCard } from '../components'
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'

import { authorType } from '../../../constants';
import { makePath } from '../../../lib';
import { getWord, WID } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  const { records } = state.eventListCard
  const { width } = state.window
  const { settings } = state.settings
  const { user } = state.authentication
  const { language } = state.user
  var record, historyRecord, commentRecord, totalCommentNum, checkedAttend, checkedInterest, enabler
  checkedAttend = false
  checkedInterest = false
  enabler = {
    editMenuItem: false,
    deleteMenuItem: false,
    historyMenuItem: false,
    tweetMenuItem: false,
  }

  record = state.eventCard.records.find((rc) => Boolean(rc.id === ownProps.eventId))
  if (record === undefined) {
    record = records.find((rc) => Boolean(rc.id === ownProps.eventId))
  }
  if (record !== undefined) {
    commentRecord = state.comment.records.find(rc => rc.id === record.commentId)
    totalCommentNum = commentRecord !== undefined ? commentRecord.comments.length : undefined
    checkedAttend = record.attend && settings ?
      record.attend.some(user => user && user.userName === settings.userName) : false
    checkedInterest = record.interest && settings ?
      record.interest.some(user => user && user.userName === settings.userName) : false
  }
  if (record !== undefined && ownProps.rev !== undefined) {
    historyRecord = state.history.records.find(rc => {
      return Boolean(
        rc.historyType === 'event' &&
        rc.eventId === parseInt(ownProps.eventId, 10) &&
        rc.rev === ownProps.rev
      )
    })
    record = historyRecord !== undefined ? { ...record, ...historyRecord } : undefined
  }

  if (record !== undefined) {
    enabler.editMenuItem = Boolean(
      record.startDate + (record.startTime ? record.startTime : 0) > Date.now() &&
      ownProps.rev === undefined &&
      (
        (
          record.authorType === parseInt(authorType.CONTRIBUTOR, 10) &&
          settings &&
          record.author.userName === settings.userName
        ) ||
        (
          record.authorType === parseInt(authorType.PROVIDER, 10) &&
          settings &&
          settings.userName !== undefined
        )
      )
    )
    enabler.deleteMenuItem = Boolean(
      ownProps.rev === undefined &&
      settings &&
      record.author.userName === settings.userName
    )
    enabler.historyMenuItem = Boolean(
      (
        record.authorType === parseInt(authorType.CONTRIBUTOR, 10) &&
        settings &&
        record.author.userName === settings.userName
      ) ||
      record.authorType === parseInt(authorType.PROVIDER, 10)
    )
    enabler.tweetMenuItem = Boolean(
      user && user.sub.match('twitter')
    )
  }
  return  ({
    width,
    settings,
    record,
    totalCommentNum,
    checkedAttend,
    checkedInterest,
    enabler,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(api.event.select({ id: parseInt(ownProps.eventId, 10) }, (response) => {
        dispatch(actions.eventCard.responseSelect(response))
        if (response.result !== true || response.records.length !== 1) {
          return
        }
        dispatch(api.comment.select(response.records[0].commentId, (response) => {
          dispatch(actions.comment.responseSelect(response))
        }))
      }))
      if (ownProps.rev !== undefined) {
        dispatch(api.event.selectHistory(ownProps.eventId, response => {
          dispatch(actions.history.responseSelectEventHistory(response))
        }))
      }
    },
    mount: () => {
      dispatch(actions.eventCard.mount())
    },
    unmount: () => {
      dispatch(actions.eventCard.unmount())
    },
    handleClickDelete: (history, language) => {
      dispatch(api.event.delete(parseInt(ownProps.eventId, 10), (response) => {
        if (response.result === false) {
          dispatch(actions.snackbar.notify(getWord(WID.EVENT_CARD.NOTIFY.MESSAGE_FAILED_TO_DELETE_EVENT, language), 'error'))
          return
        }
        history.push(makePath('/event', language))
      }))
    },
    handleClickAttend: () => {
      dispatch(api.event.selectAttend(parseInt(ownProps.eventId, 10), (response) => {
        if (response.result !== true) {
          return
        }
        dispatch(api.event.select({ id: parseInt(ownProps.eventId, 10) }, (response) => {
          dispatch(actions.eventCard.responseSelect(response))
        }))
      }))
    },
    handleClickInterest: () => {
      dispatch(api.event.selectInterest(parseInt(ownProps.eventId, 10), (response) => {
        if (response.result !== true) {
          return
        }
        dispatch(api.event.select({ id: parseInt(ownProps.eventId, 10) }, (response) => {
          dispatch(actions.eventCard.responseSelect(response))
        }))
      }))
    },
  })
}

const urlPropsQueryConfig = {
  rev: { type: UrlQueryParamTypes.number },
}


export default addUrlProps({ urlPropsQueryConfig })(connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventCard))



// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventCard.js